﻿function getForm() {
    return $("[data-fn-job-search]");
}

function setPage(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const page = button.data("pager-page");
    const form = getForm();
    form.find("#PageNumber").val(page);
    form.submit();
}

function getUrlVars(hrefUrl) {
    const vars = [];
    let hash;
    const hashes = hrefUrl.slice(hrefUrl.indexOf('?') + 1).split('&');
    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function applyPagerAttributes() {
    const pager = $("#fn-pager");
    const links = pager.find("a");
    links.each(function (index, element) {
        const alink = $(element);
        const link = alink.attr("href");
        if (!link) {
            return;
        }
        const queryString = getUrlVars(link);
        const page = queryString["page"];
        if (!page) {
            return;
        }
        alink.attr("href", "#");
        alink.attr("data-pager-page", page);
    });
}


export function setupJobsSearch() {
    if ($('[data-jobs-search]').length) {
        $(document).on("click", "[data-pager-page]", setPage);
        applyPagerAttributes();
    }
}

